/* eslint-disable no-restricted-imports */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import speedometer from '../../assets/img/speedometer.png';
import LayoutMain from 'components/Layouts/LayoutMain';

const Chats = () => (
	<LayoutMain>
		<div id="content" data-testid="content">
			{/* Topbar */}

			{/* End of Topbar */}
			{/* Begin Page Content */}
			<div className="container-fluid">
				{/* Intro */}
				<div className="row">
					<div className="col-md-12">
						<h1 className="mt-2">PCRF/PCF Acme Site A</h1>
					</div>
				</div>
				{/* Examples of boxes */}
				<div className="row mt-4">
					{/* Capacity Card Example */}
					<div className="col-xl-3 col-md-6 mb-4">
						<div className="card border-left-success h-100 py-2">
							<div className="card-body">
								<div className="row no-gutters align-items-center">
									<div className="col mr-2">
										<div className="text-xs font-weight-bold text-success text-uppercase mb-1">
											Capacity
										</div>
										<div className="h5 mb-0 font-weight-bold text-gray-800">
											105GB
										</div>
									</div>
									<div className="col-auto">
										<i className="bi-2 bi-server text-gray-300" />
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* Errors Card Example */}
					<div className="col-xl-3 col-md-6 mb-4">
						<div className="card border-left-danger h-100 py-2">
							<div className="card-body">
								<div className="row no-gutters align-items-center">
									<div className="col mr-2">
										<div className="text-xs font-weight-bold text-danger text-uppercase mb-1">
											Errors
										</div>
										<div className="h5 mb-0 font-weight-bold text-gray-800">
											23
										</div>
									</div>
									<div className="col-auto">
										<i className="bi-2 bi-activity text-gray-300" />
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* Tasks Card Example */}
					<div className="col-xl-3 col-md-6 mb-4">
						<div className="card border-left-info h-100 py-2">
							<div className="card-body">
								<div className="row no-gutters align-items-center">
									<div className="col mr-2">
										<div className="text-xs font-weight-bold text-info text-uppercase mb-1">
											Tasks
										</div>
										<div className="row no-gutters align-items-center">
											<div className="col-auto">
												<div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">
													50%
												</div>
											</div>
											<div className="col">
												<div className="progress progress-sm mr-2">
													<div
														className="progress-bar bg-info"
														role="progressbar"
														style={{width: '50%'}}
														aria-valuenow={50}
														aria-valuemin={0}
														aria-valuemax={100}
													/>
												</div>
											</div>
										</div>
									</div>
									<div className="col-auto">
										<i className="bi-2 bi-clipboard-data-fill text-gray-300" />
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* Pending Requests Card Example */}
					<div className="col-xl-3 col-md-6 mb-4">
						<div className="card border-left-warning h-100 py-2">
							<div className="card-body">
								<div className="row no-gutters align-items-center">
									<div className="col mr-2">
										<div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
											Pending Requests
										</div>
										<div className="h5 mb-0 font-weight-bold text-gray-800">
											18
										</div>
									</div>
									<div className="col-auto">
										<i className="bi-2 bi-chat-dots-fill text-gray-300" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* Status Summary & Alarm */}
				<div className="row mt-4">
					<div className="col-md-6">
						<div className="card-tasks card">
							<div className="card-header">
								<i className="bi bi-stoplights mr-3 float-left text-success bi-2-5" />
								<h2 className="card-title">Status Summary</h2>
								<p className="card-category">
									Real time information the use of the PCRF
								</p>
							</div>
							<div className="card-body">
								<div className="table-full-width">
									<table className="table table-striped table-sm h100">
										<thead />
										<tbody>
											<tr>
												<th scope="row">Hosts</th>
												<td>8 configured 8 connected</td>
											</tr>
											<tr>
												<th scope="row">External Connections</th>
												<td> 6 configured</td>
											</tr>
											<tr>
												<th scope="row">Redis Sessions</th>
												<td>687000 Objects</td>
											</tr>
											<tr>
												<th scope="row">Redis Operations</th>
												<td>200 Operations per Second</td>
											</tr>
											<tr>
												<th scope="row">Redis Cluste</th>
												<td>Connected</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div className="card-footer">
								<hr />
								<div className="stats">
									<i className="bi-1 bi-clock-history" /> Updated 3 minutes ago
								</div>
								<div className="float-right">
									<button
										type="button"
										className="border-0 p-0 bg-transparent"
										data-toggle="popover"
										data-type="html"
										data-html="true"
										title="<span class=close>×</span>"
										data-content="<div class='popoverbox'><h5>Tooltip with HTML</h5><p>Set the origin host for the diameter outgoing requests and the incoming requests if they need to be overwritten. Each home identity can then provide an origin host different from the HPLMN defined one.</p><p>More Information:</p><ul><li><a href='http://www.etsi.org/deliver/etsi_ts/123000_123099/123008/12.06.00_60/ts_123008v120600p.pdf' target='_blank'>3GPP TS 23.008</a></li><li><a href='http://www.etsi.org/deliver/etsi_ts/129200_129299/129272/12.08.00_60/ts_129272v120800p.pdf' target='_blank'>3GPP TS 29.272</a></li></ul></div>">
										<i className="bi bi-info-circle-fill text-dark" />
									</button>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6">
						<div className="card-tasks card">
							<div className="card-header">
								<i className="bi bi-bell-fill mr-3 float-left text-danger bi-2" />
								<h2 className="card-title">Alarm Registry</h2>
								<p className="card-category">Backend development</p>
							</div>
							<div className="card-body">
								<div className="table-full-width">
									<table className="table table-striped table-sm h100">
										<tbody>
											<tr>
												<td className="td-actions text-right align-middle">
													<i className="bi bi-exclamation-triangle text-warning" />
												</td>
												<td className="align-middle">
													2022-06-02 09:51:05.135 A-FE-1 CPU &gt; 90% for 1 hour
												</td>
											</tr>
											<tr>
												<td className="td-actions text-right align-middle">
													<i className="bi bi-info-circle" />
												</td>
												<td className="align-middle">
													2022.06.02 09:20:45.240 A-FE1 SCTP Link to
													dra.acme.com established
												</td>
											</tr>
											<tr>
												<td className="td-actions text-right align-middle">
													<i className="bi bi-x-circle  text-danger" />
												</td>
												<td className="align-middle  text-danger">
													2022.06.02 09:17:24.570 A-DRA1 is down; reconnecting
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<nav aria-label="Page navigation example">
									<ul className="pagination justify-content-end">
										<li className="page-item">
											<a className="page-link" href="#" aria-label="Previous">
												<span aria-hidden="true">«</span>
												<span className="sr-only">Previous</span>
											</a>
										</li>
										<li className="page-item active">
											<a className="page-link" href="#">
												1
											</a>
										</li>
										<li className="page-item">
											<a className="page-link" href="#">
												2
											</a>
										</li>
										<li className="page-item">
											<a className="page-link" href="#">
												3
											</a>
										</li>
										<li className="page-item">
											<a className="page-link" href="#" aria-label="Next">
												<span aria-hidden="true">»</span>
												<span className="sr-only">Next</span>
											</a>
										</li>
									</ul>
								</nav>
							</div>
							<div className="card-footer">
								<hr />
								<div className="stats">
									<i className="bi-1 bi-clock-history" /> Updated 3 minutes ago
								</div>
								<div className="float-right">
									<button className="border-0 bg-transparent d-inline">
										<i
											className="bi bi-arrow-right-circle-fill"
											title="test"
											data-toggle="tooltip"
											data-original-title="Other Option"
										/>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* Worst KPIs */}
				<div className="row mt-4">
					<div className="col-md-12">
						<div className="card-tasks card">
							<div className="card-header">
								<i className="bi bi-speedometer2 mr-3 float-left text-secundary bi-2" />
								<h2 className="card-title">Worst KPIs</h2>
								<p className="card-category">Backend development</p>
							</div>

							<div className="card-body">
								<div className="mt-2 d-flex justify-content-around">
									<div className="col-md-2 text-center">
										<div id="chart" className="border">
											<img src={speedometer} className="img-fluid" />
											<p className="font-weight-bold text-center">CPU A-FE-1</p>
										</div>
									</div>
									<div className="col-md-2 text-center">
										<div id="chart2" className="border">
											<img src={speedometer} className="img-fluid" />
											<p className="font-weight-bold text-center">
												MEM A-Redis-2
											</p>
										</div>
									</div>
									<div className="col-md-2 text-center">
										<div id="chart3" className="border">
											<img src={speedometer} className="img-fluid" />
											<p className="font-weight-bold text-center">
												DISK A-FE-1
											</p>
										</div>
									</div>
									<div className="col-md-2 text-center">
										<div id="chart4" className="border">
											<img src={speedometer} className="img-fluid" />
											<p className="font-weight-bold text-center">
												Diameter A-FE-1
											</p>
										</div>
									</div>
									<div className="col-md-2 text-center">
										<div id="chart5" className="border">
											<img src={speedometer} className="img-fluid" />
											<p className="font-weight-bold text-center">
												Diameter A-FE-2
											</p>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="container-fluid my-5">
										{/*Carousel Wrapper*/}
										<div
											id="multi-item-example"
											className="carousel slide carousel-multi-item"
											data-ride="carousel">
											{/*Controls*/}
											<div className="controls-top float-right">
												<a
													className="btn-floating"
													href="#multi-item-example"
													data-slide="prev">
													<i className="bi bi-arrow-left-circle-fill text-dark" />
												</a>
												<a
													className="btn-floating"
													href="#multi-item-example"
													data-slide="next">
													<i className="bi bi-arrow-right-circle-fill text-dark" />
												</a>
											</div>
											{/*/.Controls*/}
											{/*Indicators*/}
											<ol className="carousel-indicators">
												<li
													data-target="#multi-item-example"
													data-slide-to={0}
													className="active"
												/>
												<li
													data-target="#multi-item-example"
													data-slide-to={1}
												/>
											</ol>
											{/*/.Indicators*/}
											{/*Slides*/}
											<div className="carousel-inner" role="listbox">
												{/*First slide*/}
												<div className="carousel-item active">
													<div className="row mt-2 d-flex justify-content-around">
														<div className="col-md-2 text-center">
															<div className="border mb-2">
																<img
																	className="img-fluid"
																	src={speedometer}
																	alt="Card image cap"
																/>
																<p className="font-weight-bold text-center">
																	CPU A-FE-1
																</p>
															</div>
														</div>
														<div className="col-md-2 text-center clearfix d-none d-md-block">
															<div className="border mb-2">
																<img
																	className="img-fluid"
																	src={speedometer}
																	alt="Card image cap"
																/>
																<p className="font-weight-bold text-center">
																	MEM A-Redis-2
																</p>
															</div>
														</div>
														<div className="col-md-2 text-center clearfix d-none d-md-block">
															<div className="border mb-2">
																<img
																	className="img-fluid"
																	src={speedometer}
																	alt="Card image cap"
																/>
																<p className="font-weight-bold text-center">
																	DISK A-FE-1
																</p>
															</div>
														</div>
														<div className="col-md-2 text-center clearfix d-none d-md-block">
															<div className="border mb-2">
																<img
																	className="img-fluid"
																	src={speedometer}
																	alt="Card image cap"
																/>
																<p className="font-weight-bold text-center">
																	Diameter A-FE-1
																</p>
															</div>
														</div>
														<div className="col-md-2 text-center clearfix d-none d-md-block">
															<div className="border mb-2">
																<img
																	className="img-fluid"
																	src={speedometer}
																	alt="Card image cap"
																/>
																<p className="font-weight-bold text-center">
																	Diameter A-FE-2
																</p>
															</div>
														</div>
													</div>
												</div>
												{/*/.First slide*/}
												{/*Second slide*/}
												<div className="carousel-item">
													<div className="row mt-2 d-flex justify-content-around">
														<div className="col-md-2 text-center">
															<div className="border mb-2">
																<img
																	className="img-fluid"
																	src={speedometer}
																	alt="Card image cap"
																/>
																<p className="font-weight-bold text-center">
																	CPU A-FE-1
																</p>
															</div>
														</div>
														<div className="col-md-2 text-center clearfix d-none d-md-block">
															<div className="border mb-2">
																<img
																	className="img-fluid"
																	src={speedometer}
																	alt="Card image cap"
																/>
																<p className="font-weight-bold text-center">
																	MEM A-Redis-2
																</p>
															</div>
														</div>
														<div className="col-md-2 text-center clearfix d-none d-md-block">
															<div className="border mb-2">
																<img
																	className="img-fluid"
																	src={speedometer}
																	alt="Card image cap"
																/>
																<p className="font-weight-bold text-center">
																	DISK A-FE-1
																</p>
															</div>
														</div>
														<div className="col-md-2 text-center clearfix d-none d-md-block">
															<div className="border mb-2">
																<img
																	className="img-fluid"
																	src={speedometer}
																	alt="Card image cap"
																/>
																<p className="font-weight-bold text-center">
																	Diameter A-FE-1
																</p>
															</div>
														</div>
														<div className="col-md-2 text-center clearfix d-none d-md-block">
															<div className="border mb-2">
																<img
																	className="img-fluid"
																	src={speedometer}
																	alt="Card image cap"
																/>
																<p className="font-weight-bold text-center">
																	Diameter A-FE-2
																</p>
															</div>
														</div>
													</div>
												</div>
												{/*/.Second slide*/}
											</div>
											{/*/.Slides*/}
										</div>
										{/*/.Carousel Wrapper*/}
									</div>
								</div>
							</div>
							<div className="card-footer">
								<hr />
								<nav aria-label="Page navigation float-right">
									<ul className="pagination justify-content-end">
										<li className="page-item">
											<a className="page-link" href="#" aria-label="Previous">
												<span aria-hidden="true">«</span>
												<span className="sr-only">Previous</span>
											</a>
										</li>
										<li className="page-item active">
											<a className="page-link" href="#">
												1
											</a>
										</li>
										<li className="page-item">
											<a className="page-link" href="#">
												2
											</a>
										</li>
										<li className="page-item">
											<a className="page-link" href="#" aria-label="Next">
												<span aria-hidden="true">»</span>
												<span className="sr-only">Next</span>
											</a>
										</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* /.container-fluid */}
		</div>
	</LayoutMain>
);

export default Chats;
